import React, { useEffect, useState } from "react";
import { connect, ConnectedProps } from "react-redux";
import { CHAT_TYPE, POST_CONTEXT } from "../../lib/enums";
import { sendChatPost, sendMailPost } from "../../store/actions";

import { emoticons } from "../../assets/images/emoticons";

interface IPostFormProps {
  context: POST_CONTEXT;
  chatType?: CHAT_TYPE;
  recipient?: string;
  presetText?: string;
  textAreaRef: any;
}

interface IEmoticonProps {
  image: any;
  alt?: string;
  code: string;
}

const mapDispatchToProps = (dispatch: any) => ({
  sendChatPostDispatch: (
    chatType: CHAT_TYPE,
    content: string
  ) => dispatch(sendChatPost(chatType, content)),
  sendMailPostDispatch: (
    recipient: string,
    content: string
  ) => dispatch(sendMailPost(recipient, content))
})

const connector = connect(null, mapDispatchToProps);

const PostForm = React.forwardRef(({
  context,
  chatType,
  recipient,
  presetText,
  textAreaRef,
  sendChatPostDispatch,
  sendMailPostDispatch
}: IPostFormProps & ConnectedProps<typeof connector>) => {
  const [content, setContent] = useState<string>("");

  useEffect(() => {
    if (textAreaRef.current) {
      setContent(textAreaRef.current.value || presetText);
    }
  }, [textAreaRef]);

  const contentChange = (newContent: string) => setContent(newContent);

  const addEmoticon = (code: string) => {
    const caretPosition = textAreaRef.current && textAreaRef.current.selectionStart;
    const newContent = (textAreaRef.current && textAreaRef.current.value) || content;
    setContent(caretPosition
      ? `${newContent.substring(0, caretPosition)} ${code} ${newContent.substring(caretPosition)}`
      : `${newContent || ""} ${code} `);

    if (textAreaRef.current) {
      const newCaretPosition = (caretPosition || 0) + code.length + 1;
      textAreaRef.current.focus();
      textAreaRef.current.setSelectionRange(newCaretPosition, newCaretPosition);
    }
  }

  const submitPost = async () => {
    if (!content) {
      return;
    }

    await (context === POST_CONTEXT.Chat
      ? sendChatPostDispatch(chatType || CHAT_TYPE.Public, content)
      : recipient && sendMailPostDispatch(recipient, content)
    );
    setContent("");
  }

  const Emoticon = ({
    image,
    code,
    alt
  }: IEmoticonProps) => (<li>
    <img src={image}
      width="19"
      height="19"
      alt={alt || "Emoticon"}
      onClick={() => addEmoticon(code)}
    />
  </li>)

  return (
    <div className="box">
      <div className="add-comment form clearfix">
        <textarea
          ref={textAreaRef}
          name="content"
          className="add-forum-text textarea"
          rows={6} placeholder="Text of your post"
          value={content}
          onChange={e => contentChange(e.target.value)}
        />
        <div className="toolbar">
          <ul className="smiles">
            <Emoticon
              image={emoticons.smich}
              code={"{{smm"}
              alt={"Smile"}
            />
            <Emoticon
              image={emoticons.heh}
              code={"{{sml"}
              alt={"Laugh"}
            />
            <Emoticon
              image={emoticons.buu}
              code={"{{sad"}
              alt={"Sad"}
            />
            <Emoticon
              image={emoticons.ooo}
              code={"{{hmm"}
              alt={"Think"}
            />
            <Emoticon
              image={emoticons.grr}
              code={"{{grr"}
              alt={"Anger"}
            />
            <Emoticon
              image={emoticons.hul}
              code={"{{smk"}
              alt={"Stoned"}
            />
            <Emoticon
              image={emoticons.baba}
              code={"{{xyz"}
              alt={"Girl"}
            />
            <Emoticon
              image={emoticons.kenny}
              code={"{{ken"}
              alt={"Kenny"}
            />
            <Emoticon
              image={emoticons.bum}
              code={"{{bmb"}
              alt={"Bomb"}
            />
            <Emoticon
              image={emoticons.smrt}
              code={"{{dth"}
              alt={"Death"}
            />
            <Emoticon
              image={emoticons.srdce}
              code={"{{lv"}
              alt={"Love"}
            />
            <Emoticon
              image={emoticons.snek}
              code={"{{snk"}
              alt={"Snail"}
            />
            <Emoticon
              image={emoticons.prdel}
              code={"{{sht"}
              alt={"Butt"}
            />
            <Emoticon
              image={emoticons.pulitr}
              code={"{{pul"}
              alt={"Beer"}
            />
            <Emoticon
              image={emoticons.ovce}
              code={"{{ovc"}
              alt={"Sheep"}
            />
            <Emoticon
              image={emoticons.fuck}
              code={"{{fck"}
              alt={"Get off"}
            />
            <Emoticon
              image={emoticons.ok}
              code={"{{up"}
              alt={"OK"}
            />
            <Emoticon
              image={emoticons.ko}
              code={"{{dwn"}
              alt={"KO"}
            />
            <Emoticon
              image={emoticons.vict}
              code={"{{vct"}
              alt={"Victory"}
            />
            <Emoticon
              image={emoticons.bold}
              code={"{b{"}
              alt={"Bold start"}
            />
            <Emoticon
              image={emoticons.boldno}
              code={"{bb{"}
              alt={"Bold end"}
            />
            <Emoticon
              image={emoticons.under}
              code={"{u{"}
              alt={"Underscore start"}
            />
            <Emoticon
              image={emoticons.underno}
              code={"{uu{"}
              alt={"Underscore end"}
            />
            <Emoticon
              image={emoticons.ital}
              code={"{i{"}
              alt={"Italic start"}
            />
            <Emoticon
              image={emoticons.italno}
              code={"{ii{"}
              alt={"Italic end"}
            />
          </ul>
          <div className="btn-wrap">
            <a
              className={`btn btn-blank ${content ? "" : "disabled"}`}
              onClick={submitPost}
            >
              Send
            </a>
            <a className="close-reply" data-dismiss="add-comment">Cancel</a>
          </div>
        </div>
      </div>
    </div>
  )
});

export default connector(PostForm);
